export default "__VITE_ASSET__430b0164__"